import React, { useMemo } from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {
  SHOULD_DISPLAY_FEATURES_ONLY_WITH_AR3DUrls,
  SIDEBAR_WITH_FEATURES_SUBMENU,
  SQFT_APPLIANCES_WITH_SUBMENU,
} from "../../../../../constants";
import { setSQFTActiveButton, setSQFTMenuOpened } from "../../../../../../../actions/sqftMenuFunctions";
import LoadingSpinner from "../../../../../../ui/loadingSpinner";
import SQFTFeaturesHeader from "../../cabinet/toolMenu/commonParts/SQFTFeaturesHeader";
import useFetchFeatures from "../../../../../hocs/useFetchFeatures";
import FeaturesGrid from "./FeaturesGrid";
import {
  getPartIdsFromMenuOpened,
  getWizardOrFeatureGroupNavItems,
  getItemClickCallbackForPartId,
} from "../../../../../helpers/sqftNavigationHelper";

const SqftNavFeaturesGrid = (props) => {
  const { menuOpened, isMobile, windowHeight, groheFiltersSearchText, selectedFilters } = props;

  // 1.) Enter featureGroup part id that you want it to be displayed here
  const expanded = [...SIDEBAR_WITH_FEATURES_SUBMENU, ...SQFT_APPLIANCES_WITH_SUBMENU].includes(menuOpened);
  const partIds = useMemo(() => expanded ? getPartIdsFromMenuOpened(menuOpened) : [], [menuOpened, expanded]);
  const searchText = useMemo(() => expanded ? groheFiltersSearchText : '', [groheFiltersSearchText, expanded]);

  // we will get features only with thirdPartyAR3DUrls
  const shouldGetModelsOnlyWithThirdPartyAR3DUrls = SHOULD_DISPLAY_FEATURES_ONLY_WITH_AR3DUrls.includes(menuOpened);
  const { featuresData, isLoading } = useFetchFeatures(
    partIds,
    searchText,
    selectedFilters,
    shouldGetModelsOnlyWithThirdPartyAR3DUrls,
    true,
    false,
    true
  );
  const hasMultiplePartIds = partIds.length > 1;

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")}>
      <div className={"side-level2__inner"}>
        <div className="side-level2__header-sticky">
          <SQFTFeaturesHeader headerTitle={" "} partId={partIds[0]} />
        </div>
        <div className="side-level2__inner-withsidebar">
          {partIds.map((partId) => {
            const featureData = featuresData[partId];

            // 2.) Enter feature click functionality here
            const itemClickCallback = getItemClickCallbackForPartId(partId);

            return (
              <React.Fragment key={partId}>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  featureData && (
                    <FeaturesGrid
                      partId={partId}
                      navItems={getWizardOrFeatureGroupNavItems(partId, featureData)}
                      featureGroup={featureData.featureGroup}
                      isMobile={isMobile}
                      windowHeight={windowHeight}
                      itemClickCallback={itemClickCallback}
                      shouldShowFullHeight={hasMultiplePartIds}
                    />
                  )
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const { menuOpened } = store.sqftMenuState;
  const { isMobile, windowHeight } = store.serverState;
  const { groheFiltersSearchText } = store.groheState;
  const { selectedFilters } = store.filterState;

  return {
    menuOpened,
    isMobile,
    windowHeight,
    groheFiltersSearchText,
    selectedFilters, // re-render on change
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavFeaturesGrid)
);
